export default "__VITE_ASSET__DXDmJCcR__"